import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { Box } from '@mui/material';

const ValueLabelComponent = ({ children, open, value }) => (
  <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
    {children}
  </Tooltip>
);

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
};

const RangeSlider = ({ onChange, label, options, values, alignSliderToLabel, disabled }) => {
  const firstValueIndex = options.indexOf(options.find(option => values[0] === option.value));
  const secondValueIndex = options.indexOf(options.find(option => values[1] === option.value));

  const [currentValues, setCurrentValues] = useState([firstValueIndex, secondValueIndex]);

  useEffect(() => {
    setCurrentValues([firstValueIndex, secondValueIndex]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const handleChange = (event, newValues) => {
    const firstValue = options[newValues[0]].value;
    const secondValue = options[newValues[1]].value;

    onChange(event, [firstValue, secondValue]);
    setCurrentValues(newValues);
  };

  const valueLabelFormat = x => options[x].label;

  const rangeSliderMarks = [
    {
      label: options[currentValues[0]].label,
      value: 0,
    },
    {
      label: options[currentValues[1]].label,
      value: options.length - 1,
    },
  ];

  return (
    <>
      <Typography gutterBottom>{label}</Typography>
      <Box mx={alignSliderToLabel ? 1 : 0}>
        <Slider
          disabled={disabled}
          ValueLabelComponent={ValueLabelComponent}
          value={currentValues}
          onChange={handleChange}
          size="small"
          min={0}
          max={options.length - 1}
          marks={rangeSliderMarks}
          valueLabelDisplay="auto"
          valueLabelFormat={valueLabelFormat}
        />
      </Box>
    </>
  );
};

RangeSlider.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ).isRequired,
  values: PropTypes.array.isRequired,
  alignSliderToLabel: PropTypes.bool,
};

RangeSlider.defaultProps = {
  disabled: false,
  alignSliderToLabel: false,
  label: null,
};

export default RangeSlider;
